import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import { Roller } from 'react-spinners-css'
import PropTypes from 'prop-types'
Modal.setAppElement('*')

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)'
	}
}

class Loader extends React.Component {
	//static defaultProps
	//static propTypes
	render() {
		const { loading } = this.props
		return (
			<Modal isOpen={loading} style={customStyles}>
				<div className='loader_box'>
					<Roller color='#159782' />
					<span className='loader_text'>Loading</span>
				</div>
			</Modal>
		)
	}
}

// Loader.defaultProps = {
//     loading: false
// }

// Loader.propTypes = {
//     loading: PropTypes.bool
// }

const mapStateToProps = state => {
	return {
		loading: state.appReducer.loading
	}
}

export default connect(mapStateToProps)(Loader)
